export const getValidationErrors = (property: string, currentValue: string|boolean): string[] => {

  const errors = [];
  if (typeof currentValue !== "string") {
    return currentValue ? [] : ["This field is required"]
  }
  if (!currentValue) {
    errors.push("This field is required");
    return errors
  }

  switch (property) {
    case "firstName":
    case "lastName": {
      if (currentValue.length === 1) {
        errors.push("inputs.errors.shortName");
      } else if (currentValue.length > 50) {
        errors.push("inputs.errors.longName");
      }
      if (!/^[A-Z\s\'\-\&\.a-z]+$/.test(currentValue)) {
        errors.push("inputs.errors.nameIsIncorrect");
      }
      break;
    }
    case "email": {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(currentValue)) {
        errors.push("Email is invalid");
      }
      break;
    }
    case "phone": {
      if (!/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i.test(currentValue)) {
        errors.push("inputs.errors.phoneIncorrect");
      }
      break;
    }
    case "postal": {
      const regex = /[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]/;
      if (!regex.test(currentValue)) {
        errors.push("inputs.errors.incorrectPostal");
        return errors
      }
      break;
    }
  }
  return errors
}